import isEqual from "lodash/isEqual";
export const isTypeAbsolute = (timeRange) => "type" in timeRange && timeRange.type === "absolute";
export const isTypeRelative = (timeRange) => "type" in timeRange && timeRange.type === "relative";
export const isTypeRelativeWithStartOnly = (timeRange) => isTypeRelative(timeRange) && "range" in timeRange;
export const isTypeRelativeWithEnd = (timeRange) => isTypeRelative(timeRange) && "from" in timeRange;
export const isTypeKeyword = (timeRange) => "type" in timeRange && timeRange.type === "keyword";
export const isNoTimeRangeOverride = (timeRange) => timeRange !== void 0 && isEqual(timeRange, {});
export const isTimeRange = (timeRange) => timeRange && "type" in timeRange;
